import React, { ReactNode } from "react";
import DatePicker from "react-datepicker/dist/react-datepicker";

interface IAdminDatePickerProps {
  value: Date | null;
  onChange: (date: Date | null) => void;
  label: ReactNode;
}

export const AdminDatePicker = (props: IAdminDatePickerProps) => {
  return (
    <div className={`DatePicker-container`}>
      <label>{props.label}</label>
      <DatePicker
        selected={props.value as Date}
        onChange={(date: Date | null) => props.onChange(date)}
        showTimeSelect
        dateFormat="MM/dd/yyyy h:mm aa"
      />
    </div>
  );
};
